/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_TestimonialsInputs */

const en_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What students say.`)
};

const es_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que dicen los alumnos.`)
};

const de_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was Studierende sagen.`)
};

const zh_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学生怎么说。`)
};

const ar_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماذا يقول الطلاب.`)
};

const fr_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que disent les étudiants.`)
};

const vi_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Học viên nói gì về chúng tôi.`)
};

const sw_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanafunzi wanasema nini.`)
};

const th_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่นักเรียนพูด`)
};

const bs_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta kažu učenici.`)
};

const ja_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生徒の声。`)
};

const ko_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수강생들의 이야기.`)
};

const pt_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que os alunos dizem.`)
};

const it_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa dicono gli studenti.`)
};

const sv_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad eleverna säger.`)
};

const nl_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat studenten zeggen.`)
};

const da_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad eleverne siger.`)
};

const nb_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva elevene sier.`)
};

const fi_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä oppilaat sanovat?`)
};

const pl_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co mówią uczniowie.`)
};

const ru_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что говорят ученики.`)
};

const tr_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğrenciler ne diyor.`)
};

const hi_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छात्र क्या कहते हैं।`)
};

const id_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang mahasiswa katakan.`)
};

const ms_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa kata pelajar.`)
};

const cs_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To říkají studenti.`)
};

const el_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι λένε οι μαθητές;`)
};

const he_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה התלמידים אומרים`)
};

const af_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat studente sê.`)
};

const hu_home_section_testimonials = /** @type {(inputs: Home_Section_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amit a diákok mondanak.`)
};

/**
* | output |
* | --- |
* | "What students say." |
*
* @param {Home_Section_TestimonialsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_testimonials = /** @type {((inputs?: Home_Section_TestimonialsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_TestimonialsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_testimonials(inputs)
	if (locale === "de") return de_home_section_testimonials(inputs)
	if (locale === "zh") return zh_home_section_testimonials(inputs)
	if (locale === "ar") return ar_home_section_testimonials(inputs)
	if (locale === "fr") return fr_home_section_testimonials(inputs)
	if (locale === "vi") return vi_home_section_testimonials(inputs)
	if (locale === "sw") return sw_home_section_testimonials(inputs)
	if (locale === "th") return th_home_section_testimonials(inputs)
	if (locale === "bs") return bs_home_section_testimonials(inputs)
	if (locale === "ja") return ja_home_section_testimonials(inputs)
	if (locale === "ko") return ko_home_section_testimonials(inputs)
	if (locale === "pt") return pt_home_section_testimonials(inputs)
	if (locale === "it") return it_home_section_testimonials(inputs)
	if (locale === "sv") return sv_home_section_testimonials(inputs)
	if (locale === "nl") return nl_home_section_testimonials(inputs)
	if (locale === "da") return da_home_section_testimonials(inputs)
	if (locale === "nb") return nb_home_section_testimonials(inputs)
	if (locale === "fi") return fi_home_section_testimonials(inputs)
	if (locale === "pl") return pl_home_section_testimonials(inputs)
	if (locale === "ru") return ru_home_section_testimonials(inputs)
	if (locale === "tr") return tr_home_section_testimonials(inputs)
	if (locale === "hi") return hi_home_section_testimonials(inputs)
	if (locale === "id") return id_home_section_testimonials(inputs)
	if (locale === "ms") return ms_home_section_testimonials(inputs)
	if (locale === "cs") return cs_home_section_testimonials(inputs)
	if (locale === "el") return el_home_section_testimonials(inputs)
	if (locale === "he") return he_home_section_testimonials(inputs)
	if (locale === "af") return af_home_section_testimonials(inputs)
	if (locale === "hu") return hu_home_section_testimonials(inputs)
	return en_home_section_testimonials(inputs)
});